import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { addUser, getUserById, updateUser } from "../../../redux/user/action";
import { addadmin } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import UploadImage from "../Category/UploadImage";
import AddUpdateHeader from "../../Common/CardHeader/AddUpdateHeader";
import { useParams } from "react-router-dom";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { fireStore } from "../../../Firebase/Config";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";

const uniqueId1 = uuidv4();
const formData = [
  { title: "First Name", name: "first_name" },
  { title: "Last Name", name: "last_name" },

  { title: "Mobile Number", name: "mobile_number" },
  { title: "Email Address (Optional)", name: "email_id" },
  // { title: "Password", name: "password" },
  // { title: "DOB", name: "dob" },
  // { title: "Gender", name: "gender" },
  { title: "Status", name: "status" },
  // { title: "Profile Image", name: "profile_image" },
];

const initialValues = {};

const Addadmin = ({ data }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  // const [gender, setGender] = useState(1);
  const [profileimage, setProfileimage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(data?.update);
  const dispatch = useDispatch();
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);
  console.log(selectedUser, "selectedUser")

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
      setUpdate(true);
    }
  }, [id]);


  const initialValues = {
    ...formData.reduce((acc, field) => {
      acc[field.name] = selectedUser?.[field.name] || "";
      return acc;
    }, {}),
    mobile_number: selectedUser?.mobile_number || "",
    country_code: selectedUser?.country_code || "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: (value) => handelSubmit(value),
    validationSchema: addadmin(update),
  });

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`,
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };



  const handelSubmit = async (values) => {

    if (Object.keys(formik.errors).length > 0) {
      return;
    }
    setLoading(true);

    if (profileimage) {
      const storage = getStorage(fireStore);

      try {
        const uploadImage = async (file, path) => {
          if (file) {
            const imageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(imageRef, file);
            const snapshot = await uploadTask;
            return await getDownloadURL(snapshot.ref);
          }
          return "";
        };

        let maleImageUrl = "";

        if (profileimage) {
          maleImageUrl = await uploadImage(
            profileimage,
            `/Category/${uniqueId1}_male_${profileimage.name}`,
          );
        }
        const { password, ...restValues } = values;
        const countryCodeLength = values?.country_code?.length || 0;
        const mobileNumberWithoutCountryCode =
          values?.mobile_number?.slice(countryCodeLength);
        console.log(mobileNumberWithoutCountryCode, "mobileNumberWithoutCountryCode")

        const data = {
          ...restValues,
          id: id,
          // profile_image: maleImageUrl,
          mobile_number: mobileNumberWithoutCountryCode, // Use the sliced mobile number
          country_code: values?.country_code,
        };
        if (password) {
          data.password = password;
        }
        dispatch(updateUser(data, setLoading, navigate));
        setUpdate(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    } else {
      const { password, ...restValues } = values;
      const countryCodeLength = values?.country_code?.length || 0;
      const mobileNumberWithoutCountryCode =
        values?.mobile_number?.slice(countryCodeLength);

      const data = {
        ...restValues,
        id: id,
        mobile_number: values?.mobile_number, // Use the sliced mobile number
        country_code: values?.country_code,
      };
      if (password) {
        data.password = password;
      }

      dispatch(updateUser(data, setLoading, navigate));
      setUpdate(false);
    }
  };
  const navigate = useNavigate();
  console.log(formik.values, "values")
  console.log(formik.errors, "erros")
  console.log(formik.values.status, "formik values   status")
  return (
    <div className='card-head order-card order-timing'>

      <AddUpdateHeader modal={"Update User"} list={"User List"} />
      <div className="">
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            {formData.map((prop, key) => {
              if (prop.title === "Mobile Number") {
                return (
                  <div className=" col-md-4" key={key} >
                    <div className="form-group">
                      <label htmlFor={prop.name}>{t(prop.title)}</label>
                      <PhoneInput
                        country={"sa"}
                        value={
                          formik.values.mobile_number
                            ? `${formik.values.country_code}${formik.values.mobile_number}`
                            : ""
                        }
                        onChange={(phone, data) =>
                          handleCountryCode(phone, data)
                        }
                        onBlur={() => formik.setFieldTouched(prop.name, true)}
                      />
                    </div>

                    {(formik.touched.mobile_number ||
                      formik.errors.mobile_number) && (
                        <p style={{ color: "red" }}>
                          {formik.errors.mobile_number}
                        </p>
                      )}
                  </div>
                );
              }
              if (prop.name === "status") {
                const options = [
                  { value: "1", label: t("Active") },
                  { value: "2", label: t("Inactive") },
                  { value: "3", label: t("Block") },
                ];

                return (
                  <div className=" col-md-4 form-group" key={key} >
                    <label>{t(prop.title)}</label>
                    <div>
                      <ReactSelect
                        // className='form-control'
                        value={options.filter((option) =>
                          option.value == formik.values?.status,
                        )}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        options={options}
                        onChange={(selectedOption) =>
                          formik.handleChange(prop.name)(selectedOption.value)
                        }
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched[prop.name] &&
                        formik.errors[prop.name] && (
                          <div className="error">
                            {t(formik.errors[prop.name])}
                          </div>
                        )}
                    </div>
                  </div>
                );
              }

              if (prop.name === "password") {
                return (
                  <div className=" col-md-4" key={key} >
                    <div className="form-group">
                      <label>Password</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                  </div>
                );
              }

              if (prop.name === "profile_image") {
                return (
                  <UploadImage
                    files={profileimage}
                    setFiles={setProfileimage}
                    update={update}
                    prop={prop}
                    formik={formik}
                  />
                );
              }
              // if (prop.name === "gender") {
              //   const options = [
              //     { value: 1, label: t("Male") },
              //     { value: 2, label: t("Female") },
              //     // { value: 3, label: t("Both") },
              //   ];

              //   return (
              //     <Col key={key} xs={4}>
              //       <label>{t(prop.title)}</label>
              //       <div>
              //         <ReactSelect
              //           value={options.find(
              //             (option) =>
              //               option.value == formik.values?.[prop.name],
              //           )}
              //           placeholder={t(prop.title)}
              //           id={prop.name}
              //           name={prop.name}
              //           options={options}
              //           onChange={(option) => {
              //             formik.setFieldValue("gender", option?.value);
              //             setGender(option?.value);
              //           }}
              //           onBlur={formik.handleBlur}
              //         />
              //         {formik.touched[prop.name] &&
              //           formik.errors[prop.name] && (
              //             <div className="error">
              //               {t(formik.errors[prop.name])}
              //             </div>
              //           )}
              //       </div>
              //     </Col>
              //   );
              // }
              if (prop.name === "dob") {
                return (
                  <div className=" col-md-4" key={key} >
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                        type="date"
                      />
                    </div>
                  </div>
                );
              }
              if (prop.name === "email_id") {
                return (
                  <div className=" col-md-4" key={key} >
                    <div className="form-group">
                      <label>{prop?.title}</label>
                      <CustomInput
                        value={formik.values?.[prop.name]}
                        placeholder={t(prop.title)}
                        id={prop.name}
                        name={prop.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched}
                        errors={formik.errors}
                      />
                    </div>
                    {formik.values.email_id && formik.touched.email_id && formik.errors.email_id && (
                      <p style={{ color: "red" }}>{formik.errors.email_id}</p>
                    )}
                  </div>
                );
              }
              return (
                  <div className=" col-md-4" key={key} >
                  <div className="form-group">
                    <label>{prop?.title}</label>
                    <CustomInput
                      value={formik.values?.[prop.name]}
                      placeholder={t(prop.title)}
                      id={prop.name}
                      name={prop.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      touched={formik.touched}
                      errors={formik.errors}
                    />
                  </div>
                </div>
              );
            })}
            <Col md={12} className="text-center my-3 d-flex align-items-center justify-content-between" style={{ padding: '15px' }}>
              <button
                className="background-button w-25 py-3"
                disabled={loading}
                type="submit"
              >
                <span style={{ fontSize: "16px" }}>
                  {!loading ? (
                    data?.update && selectedUser?.id ? (
                      t("Update")
                    ) : (
                      t("Submit")
                    )
                  ) : (
                    <Spinner />
                  )}
                </span>
              </button>
            </Col>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Addadmin;
